var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "supsis-done-modal-fade" } }, [
    _c(
      "div",
      {
        staticClass: "supsis-done-modal-overlay-v2xuniq",
        on: { click: _vm.handleOverlayClick },
      },
      [
        _c(
          "div",
          {
            staticClass: "supsis-done-modal-container-v2xuniq",
            on: {
              click: function ($event) {
                $event.stopPropagation()
              },
            },
          },
          [
            _c("div", { staticClass: "supsis-done-modal-header-v2xuniq" }, [
              _c("div", { staticClass: "supsis-done-header-content-v2xuniq" }, [
                _c(
                  "span",
                  {
                    staticClass:
                      "material-icons supsis-done-header-icon-v2xuniq",
                  },
                  [_vm._v("flaky")]
                ),
                _vm._v(" "),
                _c("h2", { staticClass: "supsis-done-header-title-v2xuniq" }, [
                  _vm._v("Kapatılmış Görevler"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "supsis-done-close-btn-v2xuniq",
                  on: { click: _vm.handleClose },
                },
                [
                  _c("span", { staticClass: "material-icons" }, [
                    _vm._v("close"),
                  ]),
                ]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "supsis-done-modal-body-v2xuniq" },
              [
                _c("div", { staticClass: "supsis-done-control-bar-v2xuniq" }, [
                  _c("div", { staticClass: "supsis-done-action-bar-v2xuniq" }, [
                    _c(
                      "div",
                      { staticClass: "supsis-done-date-filter-v2xuniq" },
                      [
                        _c(
                          "span",
                          {
                            staticClass:
                              "material-icons supsis-done-filter-icon-v2xuniq",
                          },
                          [_vm._v("event")]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          { staticClass: "supsis-done-filter-label-v2xuniq" },
                          [_vm._v("Kapatılma Tarihi:")]
                        ),
                        _vm._v(" "),
                        _c("a-range-picker", {
                          staticClass: "supsis-done-date-range-input-v2xuniq",
                          attrs: {
                            placeholder: ["Başlangıç", "Bitiş"],
                            format: "DD/MM/YYYY",
                          },
                          on: { change: _vm.handleDateChangeDebounced },
                          model: {
                            value: _vm.dateRange,
                            callback: function ($$v) {
                              _vm.dateRange = $$v
                            },
                            expression: "dateRange",
                          },
                        }),
                        _vm._v(" "),
                        _c(
                          "transition",
                          { attrs: { name: "supsis-done-fade-scale" } },
                          [
                            _vm.dateRange && _vm.dateRange.length
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "supsis-done-filter-clear-v2xuniq",
                                    on: { click: _vm.clearDateFilter },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "material-icons" },
                                      [_vm._v("close")]
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "supsis-done-view-switcher-v2xuniq" },
                      [
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { content: "Izgara Görünümü" },
                                expression: "{ content: 'Izgara Görünümü' }",
                              },
                            ],
                            class: [
                              "supsis-done-view-btn-v2xuniq",
                              { active: _vm.viewMode === "grid" },
                            ],
                            on: {
                              click: function ($event) {
                                _vm.viewMode = "grid"
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("apps"),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { content: "Liste Görünümü" },
                                expression: "{ content: 'Liste Görünümü' }",
                              },
                            ],
                            class: [
                              "supsis-done-view-btn-v2xuniq",
                              { active: _vm.viewMode === "list" },
                            ],
                            on: {
                              click: function ($event) {
                                _vm.viewMode = "list"
                              },
                            },
                          },
                          [
                            _c("span", { staticClass: "material-icons" }, [
                              _vm._v("view_agenda"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "transition",
                  { attrs: { name: "supsis-done-fade", mode: "out-in" } },
                  [
                    _vm.loading
                      ? _c(
                          "div",
                          {
                            key: "loading",
                            staticClass: "supsis-done-content-loader-v2xuniq",
                          },
                          [
                            _c("a-spin", { attrs: { size: "large" } }),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "supsis-done-loading-text-v2xuniq",
                              },
                              [_vm._v(_vm._s(_vm.$t("task.loading")))]
                            ),
                          ],
                          1
                        )
                      : _vm.tasks && _vm.tasks.length > 0
                      ? _c(
                          "div",
                          {
                            key: "content",
                            staticClass: "supsis-done-content-area-v2xuniq",
                          },
                          [
                            _c(
                              "div",
                              {
                                class:
                                  _vm.viewMode === "grid"
                                    ? "supsis-done-tasks-grid-v2xuniq"
                                    : "supsis-done-tasks-list-v2xuniq",
                              },
                              _vm._l(_vm.tasks, function (task) {
                                return _c(
                                  "div",
                                  {
                                    key: task._id,
                                    class:
                                      _vm.viewMode === "grid"
                                        ? "supsis-done-task-grid-card-v2xuniq"
                                        : "supsis-done-task-list-card-v2xuniq",
                                    on: {
                                      click: function ($event) {
                                        return _vm.edit(task)
                                      },
                                    },
                                  },
                                  [
                                    _vm.viewMode === "grid"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "supsis-done-grid-card-inner-v2xuniq",
                                          },
                                          [
                                            task.attachments &&
                                            task.attachments.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-card-image-v2xuniq",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.getAttachmentUrl(
                                                          task.attachments[0]
                                                        ),
                                                        alt: task.title,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-card-image-v2xuniq supsis-done-card-image-placeholder-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "material-icons supsis-done-placeholder-icon-v2xuniq",
                                                      },
                                                      [_vm._v("task_alt")]
                                                    ),
                                                  ]
                                                ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "supsis-done-card-body-v2xuniq",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-card-header-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "supsis-done-card-title-v2xuniq",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(task.title)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "a-dropdown",
                                                          {
                                                            attrs: {
                                                              trigger: [
                                                                "click",
                                                              ],
                                                            },
                                                            scopedSlots: _vm._u(
                                                              [
                                                                {
                                                                  key: "overlay",
                                                                  fn: function () {
                                                                    return [
                                                                      _c(
                                                                        "a-menu",
                                                                        {
                                                                          staticClass:
                                                                            "supsis-done-task-actions-menu-v2xuniq",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "a-menu-item",
                                                                            {
                                                                              on: {
                                                                                click:
                                                                                  function (
                                                                                    $event
                                                                                  ) {
                                                                                    return _vm.edit(
                                                                                      task
                                                                                    )
                                                                                  },
                                                                              },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "span",
                                                                                {
                                                                                  staticClass:
                                                                                    "material-icons",
                                                                                },
                                                                                [
                                                                                  _vm._v(
                                                                                    "edit"
                                                                                  ),
                                                                                ]
                                                                              ),
                                                                              _vm._v(
                                                                                "\n                                                                " +
                                                                                  _vm._s(
                                                                                    _vm.$t(
                                                                                      "settings.edit"
                                                                                    )
                                                                                  ) +
                                                                                  "\n                                                            "
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ]
                                                                  },
                                                                  proxy: true,
                                                                },
                                                              ],
                                                              null,
                                                              true
                                                            ),
                                                          },
                                                          [
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-card-menu-btn-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "more_vert"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                task.tags &&
                                                task.tags.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-card-tags-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          task.tags.slice(0, 2),
                                                          function (tag) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: tag._id,
                                                                staticClass:
                                                                  "supsis-done-tag-chip-v2xuniq",
                                                                style:
                                                                  _vm.getTagStyle(
                                                                    tag.color
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      tag.name
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        task.tags.length > 2
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-tag-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      task.tags
                                                                        .length -
                                                                        2
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-card-footer-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-card-priority-v2xuniq",
                                                      },
                                                      [
                                                        _c(
                                                          _vm.getPriorityIcon(
                                                            task.priority
                                                          ),
                                                          { tag: "component" }
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-card-assignees-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          _vm
                                                            .getAssigneesUserId(
                                                              task
                                                            )
                                                            .slice(0, 2),
                                                          function (userId) {
                                                            return _c(
                                                              "Avatar",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tippy",
                                                                    rawName:
                                                                      "v-tippy",
                                                                    value: {
                                                                      content:
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ] &&
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ].email,
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    expression:
                                                                      "{\n                                                        content: users[userId] && users[userId].email,\n                                                        placement: 'top',\n                                                    }",
                                                                  },
                                                                ],
                                                                key: userId,
                                                                attrs: {
                                                                  size: 24,
                                                                  src:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].gravatar,
                                                                  username:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.getAssigneesUserId(
                                                          task
                                                        ).length > 2
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-avatar-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    +" +
                                                                    _vm._s(
                                                                      _vm.getAssigneesUserId(
                                                                        task
                                                                      ).length -
                                                                        2
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-card-stats-v2xuniq",
                                                      },
                                                      [
                                                        task.checklist &&
                                                        task.checklist.length >
                                                          0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-stat-badge-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "checklist"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.getCompletedChecklistCount(
                                                                        task
                                                                      )
                                                                    ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      task
                                                                        .checklist
                                                                        .length
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _c(
                                          "div",
                                          {
                                            staticClass:
                                              "supsis-done-list-card-inner-v2xuniq",
                                          },
                                          [
                                            task.attachments &&
                                            task.attachments.length > 0
                                              ? _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-list-thumbnail-v2xuniq",
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src: _vm.getAttachmentUrl(
                                                          task.attachments[0]
                                                        ),
                                                        alt: task.title,
                                                      },
                                                    }),
                                                  ]
                                                )
                                              : _vm._e(),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "supsis-done-list-content-v2xuniq",
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-list-header-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "h3",
                                                      {
                                                        staticClass:
                                                          "supsis-done-list-title-v2xuniq",
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(task.title)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      _vm.getPriorityIcon(
                                                        task.priority
                                                      ),
                                                      {
                                                        tag: "component",
                                                        staticClass:
                                                          "supsis-done-priority-icon-v2xuniq",
                                                      }
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                task.description
                                                  ? _c(
                                                      "p",
                                                      {
                                                        staticClass:
                                                          "supsis-done-list-description-v2xuniq",
                                                      },
                                                      [
                                                        _vm._v(
                                                          "\n                                            " +
                                                            _vm._s(
                                                              _vm.truncateText(
                                                                task.description,
                                                                100
                                                              )
                                                            ) +
                                                            "\n                                        "
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                task.tags &&
                                                task.tags.length > 0
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-list-tags-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          task.tags.slice(0, 3),
                                                          function (tag) {
                                                            return _c(
                                                              "span",
                                                              {
                                                                key: tag._id,
                                                                staticClass:
                                                                  "supsis-done-list-tag-v2xuniq",
                                                                style:
                                                                  _vm.getTagStyle(
                                                                    tag.color
                                                                  ),
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                " +
                                                                    _vm._s(
                                                                      tag.name
                                                                    ) +
                                                                    "\n                                            "
                                                                ),
                                                              ]
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        task.tags.length > 3
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-tag-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "+" +
                                                                    _vm._s(
                                                                      task.tags
                                                                        .length -
                                                                        3
                                                                    )
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    )
                                                  : _vm._e(),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "supsis-done-list-footer-v2xuniq",
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-list-assignees-v2xuniq",
                                                      },
                                                      [
                                                        _vm._l(
                                                          _vm
                                                            .getAssigneesUserId(
                                                              task
                                                            )
                                                            .slice(0, 3),
                                                          function (userId) {
                                                            return _c(
                                                              "Avatar",
                                                              {
                                                                directives: [
                                                                  {
                                                                    name: "tippy",
                                                                    rawName:
                                                                      "v-tippy",
                                                                    value: {
                                                                      content:
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ] &&
                                                                        _vm
                                                                          .users[
                                                                          userId
                                                                        ].email,
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    expression:
                                                                      "{\n                                                        content: users[userId] && users[userId].email,\n                                                        placement: 'top',\n                                                    }",
                                                                  },
                                                                ],
                                                                key: userId,
                                                                attrs: {
                                                                  size: 24,
                                                                  src:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].gravatar,
                                                                  username:
                                                                    _vm.users[
                                                                      userId
                                                                    ] &&
                                                                    _vm.users[
                                                                      userId
                                                                    ].name,
                                                                },
                                                              }
                                                            )
                                                          }
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.getAssigneesUserId(
                                                          task
                                                        ).length > 3
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-avatar-more-v2xuniq",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "\n                                                    +" +
                                                                    _vm._s(
                                                                      _vm.getAssigneesUserId(
                                                                        task
                                                                      ).length -
                                                                        3
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      2
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "supsis-done-list-meta-v2xuniq",
                                                      },
                                                      [
                                                        task.checklist &&
                                                        task.checklist.length >
                                                          0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-meta-badge-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "checklist"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.getCompletedChecklistCount(
                                                                        task
                                                                      )
                                                                    ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      task
                                                                        .checklist
                                                                        .length
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        (task.subTasks || [])
                                                          .length > 0
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "supsis-done-meta-badge-v2xuniq",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "material-icons",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "account_tree"
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(
                                                                  "\n                                                    " +
                                                                    _vm._s(
                                                                      _vm.getCompletedParentTaskCount(
                                                                        task
                                                                      )
                                                                    ) +
                                                                    "/" +
                                                                    _vm._s(
                                                                      task
                                                                        .subTasks
                                                                        .length
                                                                    ) +
                                                                    "\n                                                "
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a-dropdown",
                                                      {
                                                        attrs: {
                                                          trigger: ["click"],
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            $event.stopPropagation()
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "overlay",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "a-menu",
                                                                    {
                                                                      staticClass:
                                                                        "supsis-done-task-actions-menu-v2xuniq",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "a-menu-item",
                                                                        {
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.edit(
                                                                                  task
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "material-icons",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                "edit"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                          _vm._v(
                                                                            "\n                                                            " +
                                                                              _vm._s(
                                                                                _vm.$t(
                                                                                  "settings.edit"
                                                                                )
                                                                              ) +
                                                                              "\n                                                        "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      },
                                                      [
                                                        _c(
                                                          "button",
                                                          {
                                                            staticClass:
                                                              "supsis-done-list-menu-btn-v2xuniq",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "material-icons",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "more_vert"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                  ]
                                )
                              }),
                              0
                            ),
                          ]
                        )
                      : _c(
                          "div",
                          {
                            key: "empty",
                            staticClass: "supsis-done-empty-state-v2xuniq",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "supsis-done-empty-illustration-v2xuniq",
                              },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass:
                                      "material-icons supsis-done-empty-icon-v2xuniq",
                                  },
                                  [_vm._v("flaky")]
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "h3",
                              {
                                staticClass: "supsis-done-empty-title-v2xuniq",
                              },
                              [_vm._v("Kapatılmış görev bulunmamaktadır")]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass:
                                  "supsis-done-empty-description-v2xuniq",
                              },
                              [_vm._v("Henüz kapatılmış bir görev yok.")]
                            ),
                          ]
                        ),
                  ]
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("transition", { attrs: { name: "supsis-done-slide-up" } }, [
              !_vm.loading && _vm.tasks && _vm.tasks.length > 0
                ? _c(
                    "div",
                    { staticClass: "supsis-done-modal-footer-v2xuniq" },
                    [
                      _c(
                        "div",
                        { staticClass: "supsis-done-footer-info-v2xuniq" },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("info"),
                          ]),
                          _vm._v("\n                        Toplam "),
                          _c("strong", [_vm._v(_vm._s(_vm.totalTasks))]),
                          _vm._v(" görev\n                    "),
                        ]
                      ),
                      _vm._v(" "),
                      _c("a-pagination", {
                        staticClass: "supsis-done-custom-pagination-v2xuniq",
                        attrs: {
                          total: _vm.totalTasks,
                          pageSize: _vm.perPage,
                          showTotal: function (total, range) {
                            return range[0] + "-" + range[1]
                          },
                          showSizeChanger: false,
                        },
                        on: { change: _vm.handlePageChange },
                        model: {
                          value: _vm.currentPage,
                          callback: function ($$v) {
                            _vm.currentPage = $$v
                          },
                          expression: "currentPage",
                        },
                      }),
                    ],
                    1
                  )
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }